import { type Content, ContentType } from '@generalTypes/apiTypes';
import { clearDemarcationLinks, formatVersion } from '@store/helpers/documentHelpers';

export const getGoalIdentifier = (pathToRoot: readonly Content[]) => {
  const lastIndex = pathToRoot.length - 1;
  const ids = pathToRoot.map((item) => ({ identifier: item?.identifiers?.join(''), type: item.type })).filter((item) => item.identifier !== undefined && item.identifier !== '');
  return ids.reduce((acc, { identifier, type}, index) => {
    if (identifier === undefined || identifier === '') {
      return acc;
    }

    const isLastIteration = index === lastIndex;

    if (
      type === ContentType.CURRICULUM_ODET_SUBSECTION ||
      type === ContentType.CURRICULUM_ODET_LEERGEBIED ||
      type === ContentType.CURRICULUM_ODET_DEVELOPMENT_GOAL ||
      type === ContentType.CURRICULUM_ODET_ENDTERM
    ) {
      return isLastIteration ? `${identifier}${acc}` : `.${identifier}${acc}`;
    }

    if (type === ContentType.LLINKID_GOAL && acc !== '') {
      return `${identifier}.${acc}`; // only add the . for subgoals. in that case, acc should already have a value.
    }
    if (
      type === ContentType.CURRICULUM_ODET_KEY_COMPETENCE
    ) {
      // if there was no subsection that added a number before the dot, we remove the dot from the accumulator
      return /^\./.test(acc) ? `${identifier} ${acc.replace(/\./g, '')}` : `${identifier} ${acc}`;
    }
    if (type === ContentType.LLINKID_CURRICULUM) {
      return `${identifier} ${acc}`;
    }
    return `${identifier}${acc}`;
  }, '');
};

export const getGoalOrItemVM = (pathToRoot: readonly Content[] | null) => {
  if (!pathToRoot || pathToRoot.length === 0) {
    return undefined;
  }

  const item = pathToRoot[0];
  let descriptionText;
  let identifier;
  if (item.type === ContentType.CURRICULUM_ODET_DEVELOPMENT_GOAL) {
    descriptionText = clearDemarcationLinks(item.title);
  } else {
    descriptionText = clearDemarcationLinks(item.description);
  }
  if (
    item.type === ContentType.LLINKID_GOAL ||
    item.type === ContentType.CURRICULUM_ODET_DEVELOPMENT_GOAL
  ) {
    identifier = getGoalIdentifier(pathToRoot);
  }
  const root = pathToRoot[pathToRoot.length - 1] as Content;
  const version = formatVersion(root.$$version);
  return { key: item.key, type: item.type, descriptionText, version, identifier };
};
